import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import { autobind } from 'frontools/decorators/Autobind';
import VanillaUtils from 'frontools/utils/VanillaUtils';
import DocumentUtils from 'frontools/utils/DocumentUtils';
import { Overlay, OverlayOptions } from './Overlay';

export class MobileNav extends AbstractDispatcher {

    private _isOpen         : boolean       = false;
    private _isAnimating    : boolean       = false;

    private _el              : HTMLElement;
    private _elHamburger     : HTMLElement;
    private _elLinksWrapper  : HTMLElement;
    // private _elLinks         : NodeListOf<HTMLElement>;

    private _hamburgerTimeLine  : TimelineMax;
    // private _wrapperTimeLine    : TimelineMax;

    private _overlay            : Overlay;
    private _overlayOptions     : OverlayOptions;

    constructor() {
        super();

        this._el = document.querySelector('[data-main-nav]') as HTMLElement;
        
        this._elHamburger = this._el.querySelector('[data-hamburger]') as HTMLElement;
        this._elHamburger.addEventListener('click', this._onHamburgerClick);

        this._elLinksWrapper = this._el.querySelector('.links_wrapper') as HTMLElement;
    }

    @autobind
    private _onHamburgerClick() {
        var el = this._elLinksWrapper.cloneNode(true) as HTMLElement
        this._overlayOptions = new OverlayOptions();
        this._overlayOptions.blackBackground = true;
        this._overlayOptions.customClasses = "menu_nav";
        this._overlayOptions.wrapperCustomClasses = "menu";
        Overlay.animateHamburgerOpen(this._elHamburger, function() {
            this._overlay = new Overlay(el, this._overlayOptions)
            this._overlay.addListener(Overlay.OPEN, function() {
                this.dispatch({type: Overlay.OPEN});
                TweenMax.set(el, {display: "block"});
                TweenMax.staggerFromTo(el.querySelectorAll('a'), 0.4,{y:-50, opacity:0},{y:0, opacity:1, ease: Expo.easeOut}, 0.05);
                TweenMax.staggerFromTo(el.querySelectorAll('.social_module a'), 0.4,{scale:0, opacity:0},{delay: 0.4,scale:1, opacity:1, ease: Expo.easeOut}, 0.1);
            }.bind(this))
            this._overlay.addListener(Overlay.CLOSE, function() {
                Overlay.animateHamburgerOpen(this._elHamburger, null, true);
            }.bind(this))
        }.bind(this))
    }   
    
    public destroy() {
        if (this._overlay) this._overlay.close();
    } 

}